<template lang="pug">
  .agv-basic-article-info.cc-agv-basic-article-info
    .price
      span
        | {{price}}
      span.currency
        | {{renter.country | currencySymbol}}
    .order-info
      | за {{baseRentDuration | decline(['день', 'дня', 'дней'])}}
    .hidden-discounted-price-container
      svg(width="40" height="25" xmlns="http://www.w3.org/2000/svg")
        path(d="M2240 3262 c-58 -20 -111 -41 -118 -45 -8 -6 -12 -41 -12 -113 0 -57 -4 -104 -8 -104 -5 0 -28 23 -51 50 -23 28 -47 50 -54 50 -6 0 -42 -12 -80 -26 -61 -23 -71 -31 -89 -68 l-20 -42 30 -110 c17 -60 33 -149 37 -198 7 -95 3 -106 -42 -106 -19 0 -32 19 -78 110 -30 61 -60 110 -65 110 -5 0 -39 -14 -75 -32 l-65 -32 -69 33 -69 34 -74 -47 c-41 -25 -77 -46 -81 -46 -3 0 -19 44 -36 98 -16 53 -62 170 -102 260 -60 135 -77 166 -101 178 -17 9 -36 13 -43 10 -35 -13 -255 -160 -255 -170 0 -6 14 -47 31 -91 81 -211 118 -335 129 -437 6 -57 13 -113 16 -125 3 -17 -3 -26 -27 -38 -17 -9 -32 -15 -34 -13 -1 2 -17 32 -35 68 -51 102 -162 280 -175 280 -6 0 -34 -7 -61 -15 -27 -8 -55 -15 -61 -15 -7 0 -31 29 -54 65 -22 36 -46 65 -53 65 -9 0 -180 -132 -220 -170 -14 -14 20 -185 91 -454 l65 -250 190 -380 c133 -266 209 -406 251 -464 34 -45 66 -82 72 -82 6 0 39 41 74 92 56 81 62 94 52 115 -6 14 -9 28 -7 32 10 16 87 44 95 35 5 -5 28 -61 52 -124 37 -98 65 -147 190 -335 l147 -220 176 -150 c98 -82 214 -171 259 -198 75 -44 86 -47 131 -43 28 3 55 11 62 18 14 15 44 116 44 147 0 12 -37 92 -81 178 l-81 157 51 44 c28 24 51 50 51 57 0 7 -27 70 -60 140 -33 70 -60 128 -60 130 0 1 18 10 41 20 39 18 42 18 74 1 28 -16 38 -31 61 -95 54 -150 61 -166 85 -178 40 -21 63 -15 138 38 62 43 74 49 84 36 74 -95 162 -197 170 -197 5 0 38 25 73 56 38 32 71 54 81 52 11 -2 39 -41 68 -93 28 -50 78 -129 113 -176 52 -70 74 -91 118 -112 30 -15 61 -27 69 -27 26 0 155 70 155 83 0 8 -18 58 -41 113 -46 114 -101 276 -95 282 3 2 32 -49 64 -114 59 -118 61 -120 145 -182 46 -34 89 -62 94 -62 5 0 32 24 60 53 45 45 53 59 58 102 6 47 0 63 -94 283 -56 128 -101 239 -101 245 1 7 11 24 23 39 20 25 25 26 67 18 76 -15 128 -12 138 8 5 9 18 64 27 120 19 109 28 123 68 105 17 -8 40 -56 96 -204 41 -107 81 -206 88 -222 23 -46 445 -611 543 -728 51 -60 99 -109 107 -109 7 0 53 20 101 44 69 35 92 52 107 79 l19 36 -89 186 -89 186 38 77 38 77 -11 100 -12 99 -91 156 c-50 85 -98 165 -105 177 -13 20 -12 23 18 38 l32 17 60 -59 c49 -48 70 -80 122 -188 51 -106 73 -140 119 -185 l57 -55 82 29 c45 16 89 35 98 42 9 8 24 41 34 73 l18 60 -27 45 c-29 50 -29 51 18 108 29 36 34 38 90 38 51 0 70 6 141 45 79 43 84 47 106 102 l23 56 -28 51 c-81 147 -290 545 -418 796 -116 229 -152 308 -178 400 -18 63 -39 121 -46 129 -11 12 -33 9 -146 -19 -73 -18 -141 -37 -150 -42 -15 -7 -18 -23 -18 -96 l0 -87 -175 -88 -175 -87 -70 140 c-39 77 -76 140 -83 140 -7 0 -53 -9 -103 -20 -49 -11 -97 -20 -106 -20 -11 0 -51 45 -104 115 -48 63 -91 115 -97 115 -6 0 -52 -25 -103 -56 -75 -45 -95 -62 -110 -95 -17 -39 -17 -42 0 -87 22 -55 45 -156 46 -193 0 -27 -2 -28 -166 -86 -6 -2 -23 30 -38 71 -15 41 -34 80 -41 86 -9 8 -34 8 -82 2 -37 -6 -71 -7 -74 -3 -4 3 -30 71 -59 151 -29 80 -58 151 -65 159 -12 12 -23 9 -75 -22 -34 -21 -66 -37 -71 -37 -5 0 -25 32 -44 70 -20 39 -41 73 -48 76 -7 2 -44 -9 -81 -26 -38 -17 -74 -29 -80 -27 -7 3 -18 51 -26 118 -14 126 -23 159 -42 158 -7 0 -60 -17 -118 -37z" fill="#63BA40")
      span.currency-discount
        | {{renter.country | currencySymbol}}
      | для профи
    .magnet-headline
      el-button(type="text" size="small" @click="onClickEnter")
        | Войдите, чтобы увидеть
</template>

<script>
  import eventBus from 'Shared/eventBus'

  export default {
    name: 'agv-basic-article-info-with-magnet',
    props: {
      price: Number,
      baseRentDuration: Number,
      renter: Object
    },
    methods: {
      onClickEnter() {
        eventBus.$emit('proceedToLogin')
      }
    }
  }
</script>

<style scoped>
  .price {
    font-size: 33px;
    font-weight: bold;
    color: #000000;
    line-height: 23px;
    margin-bottom: 9px;
  }

  .currency {
    font-size: 23px;
    margin-left: 5px;
  }

  .hidden-discounted-price-container {
    margin-top: 25px;
  }

  svg {
    margin-right: -1px;
    margin-bottom: -7px;
    margin-left: -3px;
  }

  path {
    transform: scale(0.007);
  }

  .currency-discount {
    color: #63BA40;
    font-weight: bold;
    margin-right: 5px;
  }

  .magnet-headline {
    color: #888;
    font-size: 13px;
    margin-bottom: 20px;
  }

  .el-button {
    font-size: 13px;
  }
</style>
